module.exports = __webpack_public_path__ + "img/img-home-vitrine.d8bf6793.png";